<div class="form-error" *ngIf="hasError">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
</div>